<template>
  <b-row>
    <b-col cols="5">
      <b-form @submit.prevent="send()">
        <div class="form-group">
          <label for="">Nombre proveedor</label>
          <input type="text" v-model="provider.name" class="form-control" />
        </div>
        <div class="form-group">
          <label for="">RUC</label>
          <input type="text" v-model="provider.ruc" class="form-control" />
        </div>
        <div class="form-group">
          <label for="">
            <input type="checkbox" v-model="provider.owner" /> Propio
          </label>
        </div>
        <div class="form-group">
          <label for="">Ratio de vueltas</label>
          <input type="number" v-model="provider.ratio_limit" class="form-control"/>
        </div>
        <div class="form-group">
          <label for="">Pago inferior al ratio</label>
          <input type="number" v-model="provider.lower" class="form-control"/>
        </div>
        <div class="form-group">
          <label for="">Pago superior o igual al ratio</label>
            <input type="number" v-model="provider.higher" class="form-control"/>
        </div>
        <div class="form-group">
          <input type="submit" value="Enviar" class="btn btn-primary">
        </div>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import api from '@/helpers/api'
export default {
  props: ['provider_id'],
  data(){
    return{
      provider: { }
    }
  },
  mounted(){
    if(this.provider_id){
      api.get(`/provider/${this.provider_id}`).then(response => {
        this.provider = response.provider
      })
    }
  },
  methods: {
    send(){
      if(this.provider_id){
        api.put(`/provider/${this.provider_id}`, this.provider).then(response => {
          this.$toastr.success('Proveedor actualizado', 'Proveedor', {positionClass: "toast-top-center", closeButton: true});
        })
      } else {
        api.post('/provider', this.provider).then(response => {
          this.$toastr.success('Proveedor creado', 'Proveedor', {positionClass: "toast-top-center", closeButton: true});
        })
      }
    }
  }
}
</script>